import forge from 'node-forge'

const API_BASE = `${process.env.NEXT_PUBLIC_BASE_URL}/api`

function toBase64UrlFromBinaryString(binary) {
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '')
}

function toBase64UrlFromBytes(bytes) {
  return toBase64UrlFromBinaryString(String.fromCharCode(...new Uint8Array(bytes)))
}

/** HTTPS / localhost：Web Crypto；HTTP 测服 / 局域网：node-forge 兜底（同为 RSA-OAEP-SHA256） */
async function encryptWithSubtle(publicKeyPem, password) {
  const subtle = globalThis.crypto && globalThis.crypto.subtle
  if (!subtle) return null

  const pemBody = publicKeyPem.replace(
    /-----(BEGIN|END) PUBLIC KEY-----|\s/g,
    ''
  )
  const binary = atob(pemBody)

  const key = await subtle.importKey(
    'spki',
    Uint8Array.from(binary, char => char.charCodeAt(0)).buffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  )

  const encrypted = await subtle.encrypt(
    { name: 'RSA-OAEP' },
    key,
    new TextEncoder().encode(password)
  )

  return toBase64UrlFromBytes(encrypted)
}

function encryptWithForge(publicKeyPem, password) {
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem)
  // 与 Web Crypto TextEncoder / 后端 UTF-8 解密一致
  const encrypted = publicKey.encrypt(forge.util.encodeUtf8(password), 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha256.create()
    }
  })

  return toBase64UrlFromBinaryString(encrypted)
}

export async function encryptPassword(password) {
  if (!password || new TextEncoder().encode(password).byteLength > 128) {
    throw new Error('Password cannot be empty and must be at most 128 UTF-8 bytes')
  }

  const keyResponse = await fetch(
    `${API_BASE}/v2/definition/password-public-key`
  )
  const { data } = await keyResponse.json()

  if (!keyResponse.ok || data?.algorithm !== 'RSA-OAEP-256' || !data?.publicKey) {
    throw new Error('Unable to retrieve password encryption public key. Please try again later.')
  }

  const withSubtle = await encryptWithSubtle(data.publicKey, password)
  if (withSubtle) return withSubtle

  return encryptWithForge(data.publicKey, password)
}
